module.exports = __webpack_public_path__ + "static/img/A133.468cb184.jpg";